import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import MapComponent from "../../../../../../../../../../components/MapComponent";

const ModalJustificativaMapa = ({ open, onClose, data }) => {
  const { justificativaDeslocamento } = data;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    borderRadius: "20px",
    height: "80vh",
    p: 4,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <MapComponent
          data={data}
          containerStyle={{
            width: "100%",
            height: "80%",
            margin: "0 auto",
          }}
        />

        {!!justificativaDeslocamento && (
          <>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              mb={4}
            >
              Justificativa
            </Typography>
            <p>{justificativaDeslocamento}</p>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ModalJustificativaMapa;
